import React from 'react';

const FirestoreContext = React.createContext({
    characters: {},
});

export default FirestoreContext;